import { Candidate, ComparisonData, Tabulation } from "../../types";
import { useEffect, useState } from "react";

import Comparison from "./Comparison";

interface CandidateComparisonProps {
  tabulation: Tabulation;
  title: string;
  position: string;
  candidates: Candidate[];
  onClick?: () => void;
}

const CandidateComparison: React.FC<CandidateComparisonProps> = ({ tabulation, title, position, candidates, onClick }) => {
  const [comparisonData, setComparisonData] = useState<ComparisonData | null>(null);

  useEffect(() => {
    // Ensure we have at least 2 candidates
    if (candidates.length < 2) {
      setComparisonData(null);
      return;
    }

    const candidateTally = tabulation.tally[position] || {};
    const projectionTally = tabulation.projection?.[position] || {};
    
    // Calculate votes for all candidates
    const candidateVotes = candidates.map(candidate => ({
      name: candidate.name,
      color: candidate.color,
      votes: candidateTally[candidate.name] ?? 0,
      projectedVotes: projectionTally[candidate.name] ?? 0
    }));

    // Calculate total votes from candidates
    const totalCandidateVotes = candidateVotes.reduce((sum, candidate) => sum + candidate.votes, 0);
    const totalProjectedCandidateVotes = candidateVotes.reduce((sum, candidate) => sum + candidate.projectedVotes, 0);

    const data: ComparisonData = {
      title: title,
      candidates: candidateVotes,
      undecidedVotes: tabulation.totalVoters - totalCandidateVotes,
      projection: tabulation.projection ? {
        candidates: candidateVotes,
        undecidedVotes: tabulation.totalVoters - totalProjectedCandidateVotes
      } : undefined
    };
    setComparisonData(data);
  }, [tabulation, title, position, candidates]);

  return (
    <>
      { comparisonData && (
        <Comparison 
          title={comparisonData.title}
          candidates={comparisonData.candidates}
          undecidedVotes={comparisonData.undecidedVotes}
          projection={comparisonData.projection}
          onClick={onClick}
        />          
      )}    
    </>
  )
}

export default CandidateComparison;
